import { render, staticRenderFns } from "./plan-detail.vue?vue&type=template&id=6bd001b6&scoped=true&"
import script from "./plan-detail.vue?vue&type=script&lang=js&"
export * from "./plan-detail.vue?vue&type=script&lang=js&"
import style0 from "./plan-detail.vue?vue&type=style&index=0&id=6bd001b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd001b6",
  null
  
)

export default component.exports